import React from 'react';
import clsx from 'classnames';
import './index.css';

const Increment = () => {
  const incrementList = [
    {
      path: '/img/custom.png',
      title: '定制化解决方案',
      desc: '为客户量身定制，提供个性化的解决方案，满足其特定的要求。',
    },
    {
      path: '/img/services.png',
      title: '技术转让服务',
      desc: '提供高质量技术和知识产权转让服务，促进知识共享、加强产业链合作。',
    },
    {
      path: '/img/maintain.png',
      title: '维护和保养服务',
      desc: '提供定期的维护和保养服务，包括设备检修、软件升级、系统优化等，确保产品和设备保持良好的工作状态。',
    },
    {
      path: '/img/consult.png',
      title: '技术咨询服务',
      desc: '为实验室检测和管理难题提供专业咨询和帮助：解决客户燃眉之急。',
    },
  ];

  return (
    <div className={clsx('servicecontent-increment')}>
      <div className={clsx('servicecontent-increment-title')}>增值服务</div>
      <div className={clsx('servicecontent-increment-list')}>
        {incrementList?.map((v, index) => {
          return (
            <div
              className={clsx('servicecontent-increment-list-item')}
              key={index}
            >
              <img src={v.path} alt='' width={64} height={64} />
              <div className={clsx('servicecontent-increment-list-item-title')}>
                {v.title}
              </div>
              <div className={clsx('servicecontent-increment-list-item-desc')}>
                {v.desc}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Increment;
